module.exports = __webpack_public_path__ + "img/location-header_540.24b426d1.jpg";